export default function PageHeader({ overline, title, description, action }) {
    return (
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10">
            <div>
                {overline && (
                    <div className="overline text-[var(--vm-sage)] mb-2 text-xs uppercase tracking-[0.25em] font-semibold">
                        {overline}
                    </div>
                )}
                <h1 className="font-serif-display text-4xl md:text-5xl lg:text-6xl text-[var(--vm-text)] tracking-tight leading-tight">
                    {title}
                </h1>
                {description && (
                    <p className="mt-3 text-[var(--vm-text-secondary)] max-w-2xl text-base leading-relaxed">
                        {description}
                    </p>
                )}
            </div>
            {action}
        </div>
    );
}
